import settings from '@/settings';

const fileUrl = settings.system.fileUrl;
const util = {};

// 获取
util.getLocalStorage = (key, parse = false) => {
  const val = localStorage.getItem(`${key}`);
  if (!val) return val;
  if (parse) return JSON.parse(val);
  return val;
};

// 设置
util.setLocalStorage = (key, val, parse = false) => {
  if (parse) val = JSON.stringify(val);
  localStorage.setItem(`${key}`, val);
};

// 删除
util.removeLocalStorage = key => {
  localStorage.removeItem(`${key}`);
};

// 获取
util.getSessionStorage = (key, parse = false) => {
  const val = sessionStorage.getItem(`${key}`);
  if (!val) return val;
  if (parse) return JSON.parse(val);
  return val;
};

// 设置
util.setSessionStorage = (key, val, parse = false) => {
  if (parse) val = JSON.stringify(val);
  sessionStorage.setItem(`${key}`, val);
};

// 删除
util.removeSessionStorage = key => {
  sessionStorage.removeItem(`${key}`);
};

util.handleMapToList = mp => {
  return Object.keys(mp).map(key => {
    const code = Number(key);
    return {
      code: isNaN(code) ? key : code,
      label: mp[key],
    };
  });
};

util.handleListToMap = (list, key, value) => {
  return list.reduce((prev, item) => {
    prev[item[key]] = item[value]
    return prev;
  }, {});
};

util.readImg = file => {
  if (!file) {
    return;
  } else {
    let URL = window.URL || window.webkitURL;
    let ImgURL = URL.createObjectURL(file.raw); // 转化文件为本地路径资源
    return ImgURL;
  }
};

util.positionToErrorForm = () => {
  setTimeout(() => {
    const el = document.querySelectorAll('.el-form-item__error')[0];
    el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, 150);
};

util.clearObject = obj => {
  Object.keys(obj).forEach(key => {
    delete obj[key];
  });
};

util.completionUrl = url => {
  if (url.includes('http')) return url;
  return `${fileUrl}/${url}`;
};

export default util;
